/**
 * 司机任务管理 API
 */
import http from './httpRequest.js'

/**
 * 获取任务统计概览
 */
export function getTaskStatistics() {
  return http({
    url: '/driver/task/statistics',
    method: 'GET'
  })
}

/**
 * 创建接送任务
 */
export function createTask(data) {
  return http({
    url: '/driver/task/create',
    method: 'POST',
    data
  })
}

/**
 * 更新任务
 */
export function updateTask(id, data) {
  return http({
    url: `/driver/task/update/${id}`,
    method: 'PUT',
    data
  })
}

/**
 * 删除任务
 */
export function deleteTask(id) {
  return http({
    url: `/driver/task/delete/${id}`,
    method: 'DELETE'
  })
}

/**
 * 获取任务详情
 */
export function getTaskDetail(id) {
  return http({
    url: `/driver/task/detail/${id}`,
    method: 'GET'
  })
}

/**
 * 获取任务列表
 */
export function getTaskList(params) {
  return http({
    url: '/driver/task/list',
    method: 'GET',
    params
  })
}

/**
 * 取消任务
 */
export function cancelTask(id) {
  return http({
    url: `/driver/task/cancel/${id}`,
    method: 'PUT'
  })
}

/**
 * 获取行程列表
 */
export function getTripList(params) {
  return http({
    url: '/driver/task/trip/list',
    method: 'GET',
    params
  })
}

/**
 * 获取我的行程记录
 */
export function getMyTripList(params) {
  return http({
    url: '/driver/task/trip/my',
    method: 'GET',
    params
  })
}

/**
 * 获取司机接送统计
 */
export function getDriverStats() {
  return http({
    url: '/driver/task/stats',
    method: 'GET'
  })
}

/**
 * 获取教练列表
 */
export function getCoachList(keyword) {
  return http({
    url: '/employee/coach/list',
    method: 'GET',
    params: { keyword }
  })
}

/**
 * 获取司机列表
 */
export function getDriverList(keyword) {
  return http({
    url: '/employee/driver/list',
    method: 'GET',
    params: { keyword }
  })
}

/**
 * 获取学员列表（用于创建任务时选择学员）
 */
export function getStudentSelectList(params) {
  return http({
    url: '/student/list',
    method: 'GET',
    params: { ...params, page: 1, pageSize: 1000 }
  })
}
